export async function createFile(url: string, fileName: string): Promise<File> {
    const response = await fetch(url)
    const data = await response.blob()

    return new File([data], fileName)
}